/**
 * This function assigns a class to each year column based on the number of
 * quarters in the year. The classes narrow the width of the year column.
 */
export default function () {
  const quarterClasses = ['one-q', 'two-q', 'three-q', 'four-q'];
  return quarterClasses[this.yearData.quarters.length - 1];
}



// WEBPACK FOOTER //
// ./src/helpers/numQuarters.js